<template>
  <div v-if="appStateStore.loading">
    <div id="overlay">
      <div class="flex items-center justify-center w-full h-full">
        <div class="content-loading">
          <img
            src="~/assets/svg/icon-loading2.svg"
            alt="loading"
            width="300"
            height="300"
            class="mx-auto"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useAppStateStore } from '~/store-legacy/appState'

  const appStateStore = useAppStateStore()

</script>

<style scoped>
#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000a8;
  z-index: 999;
  border: 0px;
}

</style>